import axios from 'axios';
import { baseUrl, token } from '../../services/Apis';

export const usuarioActividadesExtracurApi = `${baseUrl}/usuario-actividades-extracur`;

export const allActividadesExtcurService = async (params) => {
  const res = await axios.get(`${usuarioActividadesExtracurApi}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveActividadesExtcurService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${usuarioActividadesExtracurApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(`${usuarioActividadesExtracurApi}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const deleteActividadesExtcurService = async (id) => {
  const res = await axios.delete(`${usuarioActividadesExtracurApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
